/*富文本编辑图片上传配置*/
import axios from "../../http";
import api from "../../api";
export const handlers = {
  image: function image() {
    var _this3 = this;
    var fileInput = _this3.container.querySelector('input.ql-image[type=file]');
    if (fileInput == null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg');
      fileInput.classList.add('ql-image');
      fileInput.addEventListener('change', function () {
        if (fileInput.files != null && fileInput.files[0] != null) {
          //  自定义图片上传功能       
          var formData = new FormData();
          formData.append('file', fileInput.files[0]);
          formData.append('token', sessionStorage.getItem("token"));
          axios.post(api.uploadTokenImg, formData)
            .then(response => {
              if (response.data.code == 0) {
                let length = _this3.quill.getSelection(true).index;
                //图片上传成功后，img的src需要在这里添加            
                _this3.quill.insertEmbed(length, 'image', response.data.path);
                _this3.quill.setSelection(length + 1)                   
              } else {
              }
            })
            .catch(response => {
            });
        }
      });
      _this3.container.appendChild(fileInput);
    }
    fileInput.click();
  },
  video: function video() {
    var _this3 = this;
    var fileInput = _this3.container.querySelector('input.ql-video[type=file]');
    if (fileInput == null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      fileInput.setAttribute('accept', 'video/mp4');
      fileInput.classList.add('ql-video');
      fileInput.addEventListener('change', function () {
        if (fileInput.files != null && fileInput.files[0] != null) {
          //  自定义视频上传功能     
          var formData = new FormData();
          formData.append('file', fileInput.files[0]);
          formData.append('token', sessionStorage.getItem("token"));
          axios.post(api.uploadTokenVideo, formData)
            .then(response => {
              if (response.data.code == 0) {
                let length = _this3.quill.getSelection(true).index;
                //视频上传成功后，video的src需要在这里添加   
                _this3.quill.insertEmbed(length, 'video', {url: response.data.path, poster: response.data.pic});
                _this3.quill.setSelection(length + 1)                   
              } else {
              }
            })
            .catch(response => {
            });
        }
      });
      _this3.container.appendChild(fileInput);
    }
    fileInput.click();    
  }
}

export const pasteImage = (quill) => {
  //  自定义粘贴图片功能
  quill.root.addEventListener('paste', evt => {
    if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
        evt.preventDefault();
        [].forEach.call(evt.clipboardData.files, file => {
            if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                return;
            }
            var formData = new FormData();
            formData.append('file', file);
            formData.append('token', sessionStorage.getItem("token"));
            axios.post(api.uploadTokenImg, formData)
              .then(response => {
                if (response.data.code == 0) {
                  var range = quill.getSelection();
                  if (range) {
                    quill.insertEmbed(range.index, 'image', response.data.path);
                    quill.setSelection(range.index + 1);
                  }                   
                } else {
                }
              })
              .catch(response => {
              });                      
        });
    }
  }, false);
}
 
